/**
 * Utilidades de los planes de pago (docs/planes-de-pago-fase-1-plan.md, §7).
 * Puras, para probarlas sin pintar nada.
 */

const nf2 = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const eur = v => (v == null || Number.isNaN(Number(v)) ? '—' : `${nf2.format(Number(v))} €`);

/** `2026-10-23T00:00:00Z` → «23 oct 2026», leyendo el día en UTC (así se guarda el vencimiento). */
export const fechaCuota = d =>
  d
    ? new Date(d).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' })
    : '—';

/** Hoy como `AAAA-MM-DD` en Madrid: es el día que comprueba el servidor. */
export const hoyISO = (now = new Date()) =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);

/** Suma días a un `AAAA-MM-DD`, sobre el calendario. */
export const sumarDias = (iso, dias) => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + dias)).toISOString().slice(0, 10);
};

const cents = x => Math.round((Number(x) || 0) * 100);

/**
 * «N cuotas iguales cada X días desde una fecha», repartiendo `total`. Los
 * céntimos que no caben a partes iguales van a la última, para que sumen justo.
 */
export function cuotasIguales({ total, count, everyDays, from }) {
  const n = Math.max(1, Math.floor(Number(count) || 0));
  const totalC = cents(total);
  const base = Math.floor(totalC / n);
  return Array.from({ length: n }, (_, i) => ({
    due_date: sumarDias(from, i * Math.max(1, Math.floor(Number(everyDays) || 0))),
    amount: ((i === n - 1 ? totalC - base * (n - 1) : base) / 100).toFixed(2),
  }));
}

export const sumaCuotas = cuotas => cents(cuotas.reduce((s, c) => s + (Number(c.amount) || 0), 0)) / 100;

/**
 * Lo que se puede comprobar antes de enviar. El servidor vuelve a comprobarlo
 * todo; esto es para no dejar enviar algo que ya se sabe que va a fallar.
 */
export function problemasDelPlan(cuotas, deuda, now = new Date()) {
  const out = [];
  if (!cuotas.length) out.push('Añade al menos una cuota');
  const hoy = hoyISO(now);
  cuotas.forEach((c, i) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(c.due_date || '')) out.push(`La cuota ${i + 1} no tiene fecha`);
    if (!(Number(c.amount) > 0)) out.push(`La cuota ${i + 1} tiene que ser mayor que 0`);
    if (i === 0 && c.due_date && c.due_date < hoy) out.push('La primera cuota no puede vencer antes de hoy');
    if (i > 0 && c.due_date && cuotas[i - 1].due_date && c.due_date <= cuotas[i - 1].due_date) {
      out.push(`La cuota ${i + 1} tiene que vencer después de la anterior`);
    }
  });
  if (deuda != null && cents(sumaCuotas(cuotas)) > cents(deuda)) {
    out.push(`Las cuotas suman ${eur(sumaCuotas(cuotas))} y la deuda viva es de ${eur(deuda)}`);
  }
  return out;
}

export const CANALES = [
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'email', label: 'Email' },
  { value: 'sms', label: 'SMS' },
  { value: 'call', label: 'Llamada' },
];

export const MOTIVOS = [
  { value: 'incumplido', label: 'Incumplido' },
  { value: 'renegociado', label: 'Renegociado' },
  { value: 'otro', label: 'Otro' },
];

export const ESTADO_CUOTA = {
  pagada: { label: 'Pagada', className: 'bg-emerald-100 text-emerald-800' },
  parcial: { label: 'Parcial', className: 'bg-amber-100 text-amber-800' },
  pendiente: { label: 'Pendiente', className: 'bg-slate-100 text-slate-700' },
};

export const ESTADO_PLAN = {
  vigente: 'Vigente',
  completado: 'Completado',
  cancelado: 'Cancelado',
};
